import { DividendList } from "../../../data/reports/dividends/types";
import React from "react";
import { LocalizationContext } from "../../../core/localization/Localization";
import { Column } from "material-table";
import { DisplayBoolNumber } from "../../components/common/DisplayBoolNumber";
import { Status } from "../../../data/models";
import { useAuth } from "../../../data/auth/hooks";

export const useDividendsColumns = () => {
  const {
    getString,
    getDateString,
    getFormatedNumberString,
    getDateTimeString,
  } = React.useContext(LocalizationContext);

  const [auth] = useAuth();

  return React.useMemo(
    () => [

      {
				title: getString("divDate"),
				render: dividends => getDateString(dividends.payDate),
				sorting: false,
				width: "100px",
				cellStyle: {
					maxWidth: "100px",
					minWidth: "100px",
					width: "100px",
				},
				headerStyle: {
					maxWidth: "100px",
					minWidth: "100px",
					width: "100px",
				},
			},
      {
        title: getString("divSecurityIsin"),
        field: "securityIsin",
        sorting: false,
      },
      {
        title: getString("divSecurityName"),
        field: "securityName",
        sorting: false,
      },
      {
        title: getString("divAccount"),
        field: "account",
        sorting: false,
      },
 			{
				title: getString("divQty"),
				render: dividends => getFormatedNumberString(dividends.qty) ,
				sorting: false,
				cellStyle: {
					minWidth: "130px",
					whiteSpace: "nowrap",
					textAlign: "end",
				},
				headerStyle: {
					minWidth: "130px",
					textAlign: "end",
				},
			},
      {
				title: getString("divGrossAmount"),
				render: dividends => getFormatedNumberString(dividends.grossAmt, true) ,
				sorting: false,
				cellStyle: {
					minWidth: "130px",
					whiteSpace: "nowrap",
					textAlign: "end",
				},
				headerStyle: {
					minWidth: "130px",
					textAlign: "end",
				},
			},
      {
				title: getString("divPayAmt"),
				render: dividends => getFormatedNumberString(dividends.payAmt, true) ,
				sorting: false,
				cellStyle: {
					minWidth: "130px",
					whiteSpace: "nowrap",
					textAlign: "end",
				},
				headerStyle: {
					minWidth: "130px",
					textAlign: "end",
				},
			},
      {
				title: getString("divValuta"),
				field: "currencyCode",
				sorting: false,
      },

    /*  auth.status==="successful" && auth.user.roleCode !== "MEMTRADER" &&  auth.user.roleCode !== "MEMMANAGER" &&  auth.user.roleCode !== "MEMCONTACT" ? {
        title: getString("stockFeeStatus"),
        render: (news) => (
          <DisplayBoolNumber value={news.status} thrutyValue={Status.Active} />
        ),
        customSort: (a, b) => a.status - b.status, 
      } : {},*/
    ],
    [getString, getFormatedNumberString]
  ) as Column<DividendList>[];
};
